var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{staticClass:"checkbox",attrs:{"label":_vm.label,"value":_vm.value,"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }